import { render, staticRenderFns } from "./xbc.vue?vue&type=template&id=23e445ea&"
import script from "./xbc.vue?vue&type=script&lang=js&"
export * from "./xbc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports